// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostZendeskConfigsChatAuthQuery,
    BaseResponseZendeskConfigChatFoundResponse,
} from '../../../types';

/**
 * auth
 *
 * @export
 * @tags zendesk-config-chat-controller
 * @link [POST] /zendeskConfigs/chat/auth
 */
export function postZendeskConfigsChatAuth(): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function postZendeskConfigsChatAuth(
    options: ApiOptions<never, PostZendeskConfigsChatAuthQuery>
): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function postZendeskConfigsChatAuth(
    options?: ApiOptions<never, PostZendeskConfigsChatAuthQuery>
): Promise<BaseResponseZendeskConfigChatFoundResponse> {
    return request<never, never, PostZendeskConfigsChatAuthQuery>('/zendeskConfigs/chat/auth', {
        ...options,
        method: 'post',
        __$requestCalleeName: 'postZendeskConfigsChatAuth',
    });
}

export const meta = [
    { tags: ['zendesk-config-chat-controller'], path: '/zendeskConfigs/chat/auth', method: 'post' },
];
